import './cookiesConfirmation.scss';
import React from "react";
import Cookies from "js-cookie";
import CookieConsent from "react-cookie-consent";
import { Typography } from "@mui/material";
import { useCookies } from "react-cookie";
import { EnableCookies } from "../enableCookies.tsx/enableCookies";

export const CookiesConfirmBox: React.FC<any> = (props: any) => {
  const [enableCookiePopup, setEnableCookiePopup] = React.useState(false)
  const [cookies, setCookie] = useCookies<any>();
  let enableCookie = Cookies.get('enableCookies')
  let expire = new Date();
  let days: any = 365;
  expire.setTime(+ expire + (days * 86400000));

  const acceptButton = () => {
    if (navigator.cookieEnabled && (enableCookie === undefined || enableCookie === 'false')) {
      setCookie('enableCookies', true, { path: '/', expires: expire });
      window.location.reload();
    }
    else {
      setEnableCookiePopup(true)
    }
  }

  return (
    <>
      <div className="cookiesConfirmBoxWrapper">
        <CookieConsent
          containerClasses="cookiesConfirmBox"
          debug={true}
          location="bottom"
          cookieName="enableCookies"
          overlay
          buttonText="Accept Cookies"
          buttonWrapperClasses={"buttonWrapper"}
          buttonClasses='yesButton'
          contentClasses="contentClass"
          onAccept={acceptButton}
        >
          <div className="contentClassWrapper">
            <div className="cookiesTopContent">
              <Typography className="cookiesTitle" >We understand your decision and we thank you for visiting Infraclear.</Typography>
            </div>
            <div >
              <Typography className="orderList"> Infraclear Inc. requires the use of cookies when you visit our website. Cookies are small files placed by your browser on the device you use to access the internet.
                We use:</Typography>
            </div>
            <div className="cookiesList" >
              <Typography className="unorderList"> <span className="textBold">Strictly Necessary Cookies : </span> These cookies allow you to move through our site without having to sign in again at each page and are necessary for our website to function.</Typography>
              <Typography className="unorderList"> <span className="textBold">Functional Cookies : </span>  These cookies allow us to keep the settings you have set, such as language, time zone, and other preferences and enable the basic operation of our site.  Without these cookies, certain services of our website may not function correctly.</Typography>
            </div>
            <div className="cookiesList" >
              <Typography className="unorderList">By clicking Accept, you consent to our use of strictly necessary and functional cookies.</Typography>
            </div>
            <div className="cookiesList" >
              <Typography className="unorderList">We care about your privacy, please see our <a href="https://infraclear.com/privacy-policy" target="_blank" rel='noreferrer'>Privacy Policy </a> if you have any questions about how we use your information.</Typography>
            </div>
          </div>
        </CookieConsent>
      </div>
      {
        enableCookiePopup && <EnableCookies />
      }
    </>
  )
}